import { render, staticRenderFns } from "./DeleteTruck.vue?vue&type=template&id=3601fb81&scoped=true"
import script from "./DeleteTruck.vue?vue&type=script&lang=js"
export * from "./DeleteTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3601fb81",
  null
  
)

export default component.exports